// src/components/CustomerForm.js

import React, { useState, forwardRef, useEffect,useImperativeHandle  } from 'react';
import {Modal} from 'react-bootstrap';
import DatePicker from "react-datepicker";
import axios from "axios";
 import {useNavigate, useParams} from "react-router-dom";
 import { ToastContainer, toast } from "react-toastify";
 import "react-toastify/dist/ReactToastify.css";
 
  
 const InviteCustomer = forwardRef((props, ref) => {
  const [inviteModal , setInviteModal] = useState(false);
  useImperativeHandle(ref, () => ({
      showInviteModal() {
 
          setInviteModal(true)
      }
  
    }))  
  // Form state
   const [formData, setFormData] = useState([])
 
  
   // Handle form field change
   const handleChange = (e) => {
     const { name, value } = e.target;
     setFormData({
       ...formData,
       [name]: value,
     });
   };
 
   useEffect(() => {
    if (props.data) {
      setFormData(props.data);
    }
  }, [props.data]);
    const [errors, setErrors] = useState('')
    console.log('uder',formData )
    const notifyTopRight = () => {
      toast.success("✔️ تمت عملية التعديل بنجاح", {
        position: "top-right",
        autoClose: 800,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
      });
    }; 
//--------------------------------------------------

const handleSubmit = ev => {
ev.preventDefault()
setErrors('')  
console.log('CustomerID',props.CustomerID)
if (!formData.Phone || !formData.Phone.match(/^(218)?09[123456][0-9]{7}$/)
) {

setErrors('رقم الهاتف  : 00 00 000 091 او 00 00 000 092')
console.log(errors)
}
else{
axios.put(`https://subk.education.com.ly/back/api/customers/${formData.CustomerID}`, formData)
.then(() => {
    setFormData('')
    props.parentFunction()
setErrors('')  
notifyTopRight()
setInviteModal(false)
})
.catch(function (error) {
    if (error.response) {
      // The request was made and the server responded with a status code
      // that falls out of the range of 2xx
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
    } else if (error.request) {
      // The request was made but no response was received
      // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
      // http.ClientRequest in node.js
      console.log(error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.log('Error', error.message);
    }
    console.log(error.config);
  });
 
}
}
useEffect(() => {
const handleEnterKey = (e) => {
if (e.key === 'Enter') {
e.preventDefault();
const form = e.target.form;
const fields = Array.from(form.elements).filter(el => (
  (el.tagName === 'INPUT' && !el.disabled) ||
  (el.tagName === 'TEXTAREA' && !el.disabled) ||
  (el.tagName === 'SELECT' && !el.disabled)
));      const currentFieldIndex = fields.findIndex(el => el === document.activeElement);
const nextFieldIndex = currentFieldIndex + 1;
if (nextFieldIndex < fields.length) {
  fields[nextFieldIndex].focus();
}
}
};

document.addEventListener('keydown', handleEnterKey);

return () => {
document.removeEventListener('keydown', handleEnterKey);
};
}, []);

   return (
     <Modal className="modal fade" id="exampleModal1" show={inviteModal} centered>
       <div className="modal-content">
         <div className="modal-header">
           <h1 className="modal-title fs-5" id="exampleModalLabel1">بيانات الزبون</h1>
           <button
             type="button"
             className="btn-close"
             style={{ marginLeft: 0 }}
             onClick={() => setInviteModal(false)}
           ></button>
         </div>
 
         <form onSubmit={handleSubmit}>
           <div className="modal-body">
             <div className="row">
               <div className="col-xl-12">
                 {errors && <div className="alert alert-danger">{errors}</div>}
               </div>
 
               <div className="col-xl-6">
                 <label className="form-label mt-3">الاسم <span className="text-danger">*</span></label>
                 <input  disabled='true'
                   className="form-control"
                   type="text"
                   name="FirstName"
                   value={formData.FirstName}
                   onChange={handleChange}
                   required
                 />
               </div>
 
               <div className="col-xl-6">
                 <label className="form-label mt-3">اللقب<span className="text-danger">*</span></label>
                 <input  disabled='true'
                   className="form-control"
                   type="text"
                   name="LastName"
                   value={formData.LastName}
                   onChange={handleChange}
                   required
                 />
               </div>
 
               <div className="col-xl-6">
                 <label className="form-label mt-3">رقم الهاتف</label>
                 <input  disabled='true'
                   className="form-control"
                   type="text"
                   name="Phone"
                   value={formData.Phone}
                   onChange={handleChange}
                 />
               </div>
 
               <div className="col-xl-6">
                 <label className="form-label mt-3">البريد الالكتروني<span className="text-danger">*</span></label>
                 <input  disabled='true'
                   className="form-control"
                   type="email"
                   name="Email"
                   value={formData.Email}
                   onChange={handleChange}
                   required
                 />
               </div>
 
               <div className="col-xl-6">
                 <label className="form-label mt-3">العنوان</label>
                 <input  disabled='true'
                   className="form-control"
                   type="text"
                   name="Address"
                   value={formData.Address}
                   onChange={handleChange}
                 />
               </div>
 
               <div className="col-xl-6">
                 <label className="form-label mt-3">تاريخ الميلاد</label>
                 <input  disabled='true'
                   className="form-control"
                   type="date"
                   name="DateOfBirth"
                   value={formData.DateOfBirth}
                   onChange={handleChange}
                 />
               </div>
 
               <div className="col-xl-6">
                 <label className="form-label mt-3">المهنة</label>
                 <input  disabled='true'
                   className="form-control"
                   type="text"
                   name="Occupation"
                   value={formData.Occupation}
                   onChange={handleChange}
                 />
               </div>
 
             
 
               <div className="col-xl-6">
                 <label className="form-label mt-3">مكان العمل</label>
                 <input  disabled='true'
                   className="form-control"
                   type="text"
                   name="Workplace"
                   value={formData.Workplace}
                   onChange={handleChange}
                 />
               </div>
 
               <div className="col-xl-6">
                 <label className="form-label mt-3">عنوان مكان العمل</label>
                 <input  disabled='true'
                   className="form-control"
                   type="text"
                   name="WorkplaceAddress"
                   value={formData.WorkplaceAddress}
                   onChange={handleChange}
                 />
               </div>
 
               <div className="col-xl-6">
                 <label className="form-label mt-3">ملاحظات</label>
                 <textarea   disabled='true'
                   className="form-control"
                   name="Notes"
                   value={formData.Notes}
                   onChange={handleChange}
                 />
               </div>
 
               
             </div>
           </div>
 
          
         </form>
       </div>
     </Modal>
   );
 }
 
)
export default InviteCustomer;
